import React from 'react';
import { useUser } from 'src/utils/UserContext';

const LandingPage = () =>
{
    const { user } = useUser();

    return (
        <React.Fragment>
            <p>Welcome {user?.login} to the AFT newton Dashboard. Currently this is a work in progress and is not expected to support production services.
            </p>
        </React.Fragment>
    );
};

export default LandingPage;